import { useMemo, useState, useEffect } from "react";
import { useSolicitudesCurso } from "../components/modalVerSolicitud/useSolicitudesCurso";
import { mensajeSimple, modalGuardandoCambiosModal, mensajeExitoModal } from "../../components/ui/sweetAlerts";
import { createFetchTableData } from "../../utils/createFetchTableData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { deleteWithResponse, postWithResponse } from "../../api/apis";
import Swal from "sweetalert2";
import moment from "moment";

import { ESTADO_SOL_CC, PERFIL, TIPO_SOLICITUD_ID } from "../../utils/Constants";

export const useTablaSolicitudes = () => {
  const { hideModal, objModal, objModalAdmin, visible, setVisible, setdataModal, verificarPermisosCancelar, visibleEditarModal, hideEditarModal, solicitudEditar } = useSolicitudesCurso();
  const [selectedRows, setSelectedRows] = useState([]);
  const [refreshToggle, setRefreshToggle] = useState(0);
  const [puedeEliminar, setPuedeEliminar] = useState(undefined);
  const idPerfil = localStorage.getItem("id_perfil");

  const filtrosPorPerfil = useMemo(() => {
    let params = {};

    switch (idPerfil) {
      case PERFIL.JEFE_ZONA:
        params.id_estado_solicitud = [
          ESTADO_SOL_CC.INICIAL,
          ESTADO_SOL_CC.APROBADO_JEFE_OPERACIONES_ZONA,
          ESTADO_SOL_CC.PENDIENTE_JEFE_ZONA_UNIDAD,
          ESTADO_SOL_CC.POR_APROBAR_RRHH_ZONA_UNIDAD,
          ESTADO_SOL_CC.APROBACION_AUTOMATICA_48H_JEFE_ZONA,
        ].join(",");
        params.id_tipo_solicitud = [
          TIPO_SOLICITUD_ID.CAMBIO_CARGO,
          TIPO_SOLICITUD_ID.CAMBIO_UNIDAD,
          TIPO_SOLICITUD_ID.CAMBIO_INSTALACION,
          TIPO_SOLICITUD_ID.RENOVACION_PLAZO,
        ].join(",");
        break;
      case PERFIL.RRHH:
        params.id_estado_solicitud = [
          ESTADO_SOL_CC.INICIAL,
          ESTADO_SOL_CC.APROBADO_JEFE_OPERACIONES_ZONA,
          ESTADO_SOL_CC.POR_APROBAR_RRHH_ZONA_UNIDAD,
          ESTADO_SOL_CC.APROBACION_AUTOMATICA_48H_JEFE_ZONA,
        ].join(",");
        params.id_tipo_solicitud = "";
        break;
      case PERFIL.ADMINISTRADOR:
        params.id_estado_solicitud = String(ESTADO_SOL_CC.INICIAL); // en curso creadas por mí
        params.id_tipo_solicitud = "";
        params.creadas_por_mi = true;
        break;
      default:
        break;
    }

    Object.keys(params).forEach(key => {
      if (params[key] === "" || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    return params;
  }, [idPerfil]);

  const fetchTableData = useMemo(
    () =>
      createFetchTableData({
        url: "cc/solicitudes_paginadas",
        initialSortBy: "fecha_inicio_cambio",
        initialSortDir: "desc",
        extraParams: filtrosPorPerfil,
      }),
    [filtrosPorPerfil],
  );

  const mostrarReporteMasivo = (accion, resData) => {
    const { procesadas = 0, omitidas = 0, detalles_procesadas = [], detalles_omitidas = [] } = resData || {};
    const esAprobar = accion === "aprobar";
    const titulo = esAprobar ? "Informe de Aprobación Masiva" : "Informe de Rechazo Masivo";

    let htmlContent = `<div class="text-start" style="font-size: 14px; color: #0b2c4d;">`;

    if (detalles_procesadas.length > 0) {
      htmlContent += `
        <details class="datatable-report-accordion mb-3">
          <summary class="datatable-report-accordion-header">
            <span>${esAprobar ? "Procesadas con éxito" : "Rechazadas con éxito"}</span>
            <span class="badge rounded-pill bg-success px-3 py-1" style="font-size: 12px; font-weight: 600;">
              ${procesadas} ${procesadas === 1 ? "solicitud" : "solicitudes"}
            </span>
          </summary>
          <div class="datatable-report-scroll-indep">
            ${detalles_procesadas.map(item => `
              <div class="datatable-report-item">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div class="fw-bold" style="color: #0b2c4d;">${item.nombre}</div>
                  <span class="badge rounded-pill" style="background-color: #e6f0fa; color: #1e5a96; border: 1px solid #b8d5f3; font-size: 11px; font-weight: 700; padding: 3px 8px;">
                    #${item.id}
                  </span>
                </div>
                <div class="d-flex align-items-center justify-content-between text-muted" style="font-size: 12px;">
                  <span>RUT: <strong>${item.rut}</strong></span>
                  ${item.tipo ? `<span class="badge bg-light text-secondary border px-2 py-1">${item.tipo}</span>` : ''}
                </div>
              </div>
            `).join('')}
          </div>
        </details>
      `;
    }

    if (detalles_omitidas.length > 0) {
      htmlContent += `
        <details class="datatable-report-accordion mb-2">
          <summary class="datatable-report-accordion-header">
            <span>Solicitudes omitidas</span>
            <span class="badge rounded-pill bg-danger px-3 py-1" style="font-size: 12px; font-weight: 600;">
              ${omitidas} ${omitidas === 1 ? "solicitud" : "solicitudes"}
            </span>
          </summary>
          <div class="datatable-report-scroll-indep">
            ${detalles_omitidas.map(item => `
              <div class="datatable-report-item">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div class="fw-bold" style="color: #0b2c4d;">
                    ${item.nombre} <span class="text-muted fw-normal" style="font-size: 12px;">(${item.rut})</span>
                  </div>
                  <span class="badge rounded-pill bg-secondary" style="font-size: 11px; font-weight: 700; padding: 3px 8px;">
                    #${item.id}
                  </span>
                </div>
                ${item.tipo ? `<div class="text-muted mb-1" style="font-size: 12px;">Tipo: <strong>${item.tipo}</strong></div>` : ''}
                <div style="font-size: 12px; color: #5a738e;">
                  <strong>Estado actual:</strong> ${item.motivo}
                </div>
              </div>
            `).join('')}
          </div>
        </details>
      `;
    }

    htmlContent += `</div>`;

    Swal.fire({
      title: titulo,
      html: htmlContent,
      confirmButtonText: "Entendido",
      buttonsStyling: false,
      customClass: {
        popup: "datatable-sweetalert-popup",
        title: "datatable-sweetalert-title",
        confirmButton: `btn ${esAprobar ? "btn-success" : "btn-danger"} datatable-sweetalert-confirm-btn`,
      },
      backdrop: "rgba(11, 44, 77, 0.4)",
      allowOutsideClick: false,
    });
  };

  const handleAprobarGrupo = () => {
    if (!selectedRows.length) return;

    Swal.fire({
      title: "¿Aprobar solicitudes seleccionadas?",
      html: `
        <p style="color: #4a5568; font-size: 15px;" class="mb-0">
          Se procesará la aprobación de <strong style="color: #198754;">${selectedRows.length}</strong> 
          ${selectedRows.length === 1 ? "solicitud seleccionada" : "solicitudes seleccionadas"}.
        </p>
      `,
      showCancelButton: true,
      confirmButtonText: "Sí, aprobar",
      cancelButtonText: "Cancelar",
      buttonsStyling: false,
      customClass: {
        popup: "datatable-sweetalert-popup",
        title: "datatable-sweetalert-title",
        confirmButton: "btn btn-success datatable-sweetalert-confirm-btn me-2",
        cancelButton: "btn btn-secondary datatable-sweetalert-cancel-btn",
      },
      backdrop: "rgba(11, 44, 77, 0.4)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        modalGuardandoCambiosModal("Procesando aprobación masiva...");
        try {
          const resp = await postWithResponse("cc/accionmasiva", null, {
            id_solicitudes: selectedRows,
            accion: "aprobar",
            observacion: "",
          });
          if (resp?.status === 200 && resp?.data?.status === "success") {
            setSelectedRows([]);
            window.dispatchEvent(new Event("refresh_solicitudes_table"));
            mostrarReporteMasivo("aprobar", resp.data.data);
          } else {
            mensajeSimple("error", resp?.data?.message || "No se pudieron procesar las solicitudes", 3000);
          }
        } catch (error) {
          console.error("Error en aprobación masiva:", error);
          mensajeSimple("error", "Ocurrió un error al procesar las solicitudes", 3000);
        }
      }
    });
  };

  const handleRechazarGrupo = () => {
    if (!selectedRows.length) return;

    Swal.fire({
      title: "¿Rechazar solicitudes seleccionadas?",
      html: `
        <p style="color: #4a5568; font-size: 15px;" class="mb-2">
          Por favor ingrese la observación de rechazo para las 
          <strong style="color: #dc3545;">${selectedRows.length}</strong> 
          ${selectedRows.length === 1 ? "solicitud seleccionada" : "solicitudes seleccionadas"}:
        </p>
      `,
      input: "textarea",
      inputPlaceholder: "Escriba la observación aquí...",
      showCancelButton: true,
      confirmButtonText: "Sí, rechazar",
      cancelButtonText: "Cancelar",
      buttonsStyling: false,
      customClass: {
        popup: "datatable-sweetalert-popup",
        title: "datatable-sweetalert-title",
        confirmButton: "btn btn-danger datatable-sweetalert-confirm-btn me-2",
        cancelButton: "btn btn-secondary datatable-sweetalert-cancel-btn",
        input: "datatable-sweetalert-input form-control",
      },
      backdrop: "rgba(11, 44, 77, 0.4)",
      inputValidator: (value) => {
        if (!value?.trim()) {
          return "Debe ingresar una observación para rechazar.";
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed && result.value) {
        modalGuardandoCambiosModal("Procesando rechazo masivo...");
        try {
          const resp = await postWithResponse("cc/accionmasiva", null, {
            id_solicitudes: selectedRows,
            accion: "rechazar",
            observacion: result.value.trim(),
          });
          if (resp?.status === 200 && resp?.data?.status === "success") {
            setSelectedRows([]);
            window.dispatchEvent(new Event("refresh_solicitudes_table"));
            mostrarReporteMasivo("rechazar", resp.data.data);
          } else {
            mensajeSimple("error", resp?.data?.message || "No se pudieron procesar las solicitudes", 3000);
          }
        } catch (error) {
          console.error("Error en rechazo masivo:", error);
          mensajeSimple("error", "Ocurrió un error al procesar las solicitudes", 3000);
        }
      }
    });
  };

  useEffect(() => {
    const handleRefresh = () => {
      setRefreshToggle((prev) => prev + 1);
    };
    window.addEventListener("refresh_solicitudes_table", handleRefresh);
    return () => window.removeEventListener("refresh_solicitudes_table", handleRefresh);
  }, []);

  const eliminarSolicitudInicial = async (id) => {
    Swal.close();
    modalGuardandoCambiosModal("Eliminando solicitud...");
    try {
      const resp = await deleteWithResponse("cancelarsolicitud", null, { id_solicitud: id });

      if ([200].includes(resp?.status)) {
        mensajeExitoModal({ titulo: "¡Solicitud eliminada correctamente!", texto: "", tiempo: 2200 });
        setTimeout(() => {
          hideModal();
          const closeBtn = document.querySelector("button.btn-close");
          if (closeBtn) closeBtn.click();
          window.dispatchEvent(new Event("refresh_solicitudes_table"));
        }, 1500);
      }
      else {
        mensajeSimple('error', resp?.data?.message || 'No fue posible eliminar la solicitud', 2500);
      }
    } catch (error) {
      console.log("Error al eliminar la solicitud:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al eliminar la solicitud.',
      });
    }
  };

  const verPermiso = async (id) => {
    if (!id) return;
    const resp = await verificarPermisosCancelar(id);
    setPuedeEliminar(resp.puede_eliminar);
  };

  const columnsDef = useMemo(() => {
    const esRRHH = String(idPerfil) === PERFIL.RRHH;
    const esJefeZona = String(idPerfil) === PERFIL.JEFE_ZONA;
    const deshabilitarBusquedaOrden = esRRHH || esJefeZona;

    return [
      {
        key: "id",
        label: "ID Solicitud",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        isVisible: false,
        render: (_, row) => row.id,
      },
      {
        key: "colaborador",
        label: "Colaborador",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        minWidth: "250px",
        render: (_, row) => `${row.persona?.nombre || ""} ${row.persona?.apellido_pat || ""} ${row.persona?.apellido_mat || ""}`.trim(),
      },
      {
        key: "rut",
        label: "RUT",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        minWidth: "90px",
        render: (_, row) => row.persona?.identificacion || "",
      },
      {
        key: "instalacion_actual",
        label: "Instalación de origen",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        render: (_, row) => row.instalacion_actual || "No Aplica",
      },
      {
        key: "nombre_cargo_actual",
        label: "Cargo actual",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        render: (_, row) => (row.nombre_cargo_actual ? row.nombre_cargo_actual.split("|")[1] || row.nombre_cargo_actual : ""),
      },
      {
        key: "descripcion_unidad_temporis",
        label: "Nuevo Cargo Temporis",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        render: (_, row) => (row.descripcion_unidad_temporis ? row.descripcion_unidad_temporis.split(" - ")[1] || row.descripcion_unidad_temporis : ""),
      },
      {
        key: "fecha_inicio_cambio",
        label: "Fecha inicio cambio",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        type: "date",
        minWidth: "90px",
      },
      {
        key: "tipo_solicitud",
        label: "Tipo solicitud",
        sortable: !deshabilitarBusquedaOrden,
        searchable: !deshabilitarBusquedaOrden,
        render: (_, row) => row.tipo_solicitud_cambio_contraactual?.nombre || "",
      },
      {
        key: "estado",
        label: "Estado actual",
        headerAlign: "left",
        sortable: !deshabilitarBusquedaOrden,
        searchable: false,
        render: (_, row) => row.estado_solicitud_cambio_contractual?.nombre || "",
      },
      {
        key: "acciones",
        label: "Acciones",
        stickyRight: true,
        sortable: false,
        searchable: false,
        headerAlign: "center",
        dataAlign: "center",
        minWidth: "110px",
        render: (_, row) => {
          const fueVistoJefe = Boolean(row.fecha_visto_jefe_zona);
          const idEstado = Number(row.id_estado_solicitud || row.estado_solicitud_cambio_contractual?.id);
          const idTipo = Number(row.id_tipo_solicitud || row.tipo_solicitud_cambio_contraactual?.id);

          let btnStyle = { color: "#2a77b9", border: "1px solid #cce0f0", background: "#ffffff" };
          let btnClass = "btn btn-light px-3 py-1 fw-bold rounded-pill d-inline-flex align-items-center shadow-sm transition-all";
          let titleText = "Ver solicitud";

          if (esRRHH) {
            const esDesvinculacionInicial =
              idTipo === TIPO_SOLICITUD_ID.DESVINCULACION &&
              idEstado === ESTADO_SOL_CC.INICIAL;

            const esPendienteRRHH =
              esDesvinculacionInicial ||
              [
                ESTADO_SOL_CC.APROBADO_JEFE_OPERACIONES_ZONA,
                ESTADO_SOL_CC.POR_APROBAR_RRHH_ZONA_UNIDAD,
                ESTADO_SOL_CC.APROBACION_AUTOMATICA_48H_JEFE_ZONA,
              ].includes(idEstado);

            if (esPendienteRRHH) {
              btnStyle = { color: "#ffffff", backgroundColor: "#2a77b9", border: "none" };
              btnClass = "btn px-3 py-1 fw-bold rounded-pill d-inline-flex align-items-center shadow-sm transition-all";
              titleText = "Pendiente de gestión RRHH - Hacer clic para revisar";
            }
          } else if (esJefeZona) {
            if (!fueVistoJefe) {
              btnStyle = { color: "#ffffff", backgroundColor: "#2a77b9", border: "none" };
              btnClass = "btn px-3 py-1 fw-bold rounded-pill d-inline-flex align-items-center shadow-sm transition-all";
              titleText = "Sin ver - Hacer clic para revisar";
            } else {
              btnStyle = { color: "#64748b", backgroundColor: "#f1f5f9", border: "1px solid #cbd5e1" };
              btnClass = "btn px-3 py-1 fw-semibold rounded-pill d-inline-flex align-items-center transition-all";
              titleText = `Vista el ${moment(row.fecha_visto_jefe_zona).format("DD/MM/YYYY HH:mm")}`;
            }
          }

          return (
            <div className="d-flex gap-2 align-items-center justify-content-center w-100 px-1">
              <button
                className={`${btnClass} text-nowrap`}
                style={btnStyle}
                title={titleText}
                onClick={() => {
                  if (esJefeZona && !row.fecha_visto_jefe_zona) {
                    row.fecha_visto_jefe_zona = new Date().toISOString();
                  }
                  setdataModal(row);
                  setVisible(true);
                  if (row?.id && esJefeZona) {
                    postWithResponse("cc/marcarvisto", null, { id_solicitud: row.id });
                  }
                }}
              >
                Ver <FontAwesomeIcon className="ms-1" icon={faEye} />
              </button>
            </div>
          );
        },
      },
    ];
  }, [idPerfil, setdataModal, setVisible]);

  return {
    idPerfil,
    filtrosPorPerfil,
    fetchTableData,
    columnsDef,
    selectedRows,
    setSelectedRows,
    handleAprobarGrupo,
    handleRechazarGrupo,
    visible,
    hideModal,
    objModal,
    objModalAdmin,
    refreshToggle,
    verPermiso,
    puedeEliminar,
    eliminarSolicitudInicial,
    visibleEditarModal,
    hideEditarModal,
    solicitudEditar,
  };
};
